/* eslint-disable func-call-spacing */
const LandSketch = () => import('~src/customReports/LandSketch.vue')
const DescriptiveMemorial = () => import('~src/customReports/DescriptiveMemorial.vue')
const DocumentPrint = () => import('~src/customReports/DocumentPrint.vue')
const PaymentBookPage = () => import('~src/customReports/PaymentBookPage.vue')

export default [
  {
    name: 'land-memorial',
    path: '/report/:projectId/descriptive-memorial/:landId',
    component: DescriptiveMemorial
  },
  {
    name: 'land-sketch',
    path: '/report/:projectId/lot-sketch/:landId',
    component: LandSketch
  },
  {
    name: 'document-print',
    path: '/report/document-print/:documentId',
    component: DocumentPrint
  },
  {
    name: 'payment-book',
    path: '/report/payment-book/:installmentGroupId',
    component: PaymentBookPage
  }
]
